import { render, staticRenderFns } from "./ResponsivePage.vue?vue&type=template&id=d97dcaa4&scoped=true&"
import script from "./ResponsivePage.vue?vue&type=script&lang=js&"
export * from "./ResponsivePage.vue?vue&type=script&lang=js&"
import style0 from "./ResponsivePage.vue?vue&type=style&index=0&id=d97dcaa4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d97dcaa4",
  null
  
)

export default component.exports